var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-browse", {
    attrs: {
      "data-source": _vm.dataSource,
      "selected-items": _vm.selectedItems,
      "url-query-params": "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }